/**
 * Skinbetter Sale Signup — landing page form.
 * Captures email + phone, sends the same Klaviyo calls as the password gate,
 * then shows a thank-you message. Fully isolated from password-gate.js.
 */
(function () {
  class SkinbetterSignup {
    constructor(root) {
      this.root = root;
      this.config = this.loadConfig();
      this.form = root.querySelector('[data-skinbetter-signup-form]');
      this.emailInput = root.querySelector('[data-skinbetter-signup-email]');
      this.phoneInput = root.querySelector('[data-skinbetter-signup-phone]');
      this.submitBtn = root.querySelector('[data-skinbetter-signup-submit]');
      this.spinner = root.querySelector('[data-skinbetter-signup-spinner]');
      this.errorBox = root.querySelector('[data-skinbetter-signup-error]');
      this.errorText = root.querySelector('[data-skinbetter-signup-error-text]');
      this.thankyou = root.querySelector('[data-skinbetter-signup-thankyou]');

      if (!this.form) return;
      this.bindEvents();
    }

    loadConfig() {
      const el = this.root.querySelector('[data-skinbetter-signup-config]');
      if (!el) return {};
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        console.error('Skinbetter Signup: bad config JSON', e);
        return {};
      }
    }

    bindEvents() {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.handleSubmit();
      });
    }

    handleSubmit() {
      const email = this.emailInput ? this.emailInput.value.trim() : '';
      const phone = this.phoneInput ? this.phoneInput.value.trim() : '';

      if (!email || !phone) {
        this.showError('Please provide both email and phone number');
        return;
      }

      this.setLoading(true);
      this.hideError();

      try {
        this.submitToKlaviyo(email, phone);
        this.showThankYou();
      } catch (error) {
        console.error('Skinbetter signup error:', error);
        this.showError('Something went wrong. Please try again.');
      } finally {
        this.setLoading(false);
      }
    }

    submitToKlaviyo(email, phone) {
      window._learnq = window._learnq || [];

      window._learnq.push(['identify', {
        '$email': email,
        '$phone_number': phone,
        'requested_code': true,
        'campaign': this.config.campaign || 'skinbetter_sale_2026',
        'request_date': new Date().toISOString(),
        'page_type': 'landing',
        'page_url': window.location.href
      }]);

      if (this.config.klaviyoListId) {
        window._learnq.push(['subscribe', {
          list: this.config.klaviyoListId,
          email: email
        }]);
      }

      window._learnq.push(['track', 'Requested Skinbetter Sale Code', {
        'page_type': 'landing',
        'page_url': window.location.href
      }]);
    }

    setLoading(isLoading) {
      if (this.submitBtn) this.submitBtn.disabled = isLoading;
      if (this.spinner) this.spinner.classList.toggle('hidden', !isLoading);
    }

    showError(message) {
      if (this.errorText) this.errorText.textContent = message;
      if (this.errorBox) this.errorBox.style.display = '';
    }

    hideError() {
      if (this.errorBox) this.errorBox.style.display = 'none';
    }

    showThankYou() {
      if (this.form) this.form.classList.add('hidden');
      if (this.thankyou) this.thankyou.classList.remove('hidden');
    }
  }

  function init() {
    document.querySelectorAll('[data-skinbetter-signup]').forEach(function (root) {
      new SkinbetterSignup(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
